import { Component } from '@angular/core';

@Component({
  selector: 'app-workflow',
  standalone: true,
  templateUrl: './workflow.html',
  styleUrls: ['./workflow.scss'],
})
export class Workflow {}